import { render, staticRenderFns } from "./PowerChatView.vue?vue&type=template&id=77067d42&scoped=true"
import script from "./PowerChatView.vue?vue&type=script&lang=js"
export * from "./PowerChatView.vue?vue&type=script&lang=js"
import style0 from "./PowerChatView.vue?vue&type=style&index=0&id=77067d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77067d42",
  null
  
)

export default component.exports